export default "__VITE_ASSET__401fca01__"